export default __webpack_public_path__ + "static/media/clearReportData.cc957be9.svg";